// src/features/tidsregistering/hooks/useDayOverviews.js
import { useState, useCallback } from 'react';
import { dayOverviewsAPI } from '../services/dayOverviews';
import { useApi } from '../../../hooks/api/useApi';

export function useDayOverviews() {
  const [dayOverview, setDayOverview] = useState(null);
  const [dayOverviews, setDayOverviews] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchDayOverview = useCallback(async (dayOverviewId) => {
    const result = await execute(() => dayOverviewsAPI.getDayOverview(dayOverviewId));
    if (result.success) setDayOverview(result.data ?? null);
    return result;
  }, [execute]);

  const fetchForDate = useCallback(async (staffMemberId, date) => {
    const result = await execute(() => dayOverviewsAPI.getDayOverviewForDate(staffMemberId, date));
    if (result.success) setDayOverview(result.data ?? null);
    return result;
  }, [execute]);

  const fetchForStaff = useCallback(async (staffMemberId, startDate, endDate) => {
    const result = await execute(() => dayOverviewsAPI.listForStaff(staffMemberId, startDate, endDate));
    if (result.success) setDayOverviews(result.data?.day_overviews ?? []);
    return result;
  }, [execute]);

  const fetchForDepartment = useCallback(async (startDate, endDate) => {
    const result = await execute(() => dayOverviewsAPI.listForDepartment(startDate, endDate));
    if (result.success) setDayOverviews(result.data?.day_overviews ?? []);
    return result;
  }, [execute]);

  const approveByUser = useCallback(async (dayOverviewId) => {
    const result = await execute(() => dayOverviewsAPI.approveByUser(dayOverviewId));
    if (result.success) setDayOverview(result.data ?? null);
    return result;
  }, [execute]);

  const approveByAdmin = useCallback(async (dayOverviewId, data) => {
    const result = await execute(() => dayOverviewsAPI.approveByAdmin(dayOverviewId, data));
    if (result.success) setDayOverview(result.data ?? null);
    return result;
  }, [execute]);

  const revokeUserApproval = useCallback(async (dayOverviewId) => {
    const result = await execute(() => dayOverviewsAPI.revokeUserApproval(dayOverviewId));
    if (result.success) setDayOverview(result.data ?? null);
    return result;
  }, [execute]);

  const updateTimeDetailCode = useCallback(async (timeDetailId, data) => {
    return execute(() => dayOverviewsAPI.updateTimeDetailCode(timeDetailId, data));
  }, [execute]);

  const recalculateBalances = useCallback(async (dayOverviewId) => {
    return execute(() => dayOverviewsAPI.recalculateBalances(dayOverviewId));
  }, [execute]);

  const addComment = useCallback(async (dayOverviewId, data) => {
    return execute(() => dayOverviewsAPI.addComment(dayOverviewId, data));
  }, [execute]);

  return {
    dayOverview,
    dayOverviews,
    loading,
    error,
    clearError,
    fetchDayOverview,
    fetchForDate,
    fetchForStaff,
    fetchForDepartment,
    approveByUser,
    approveByAdmin,
    revokeUserApproval,
    updateTimeDetailCode,
    recalculateBalances,
    addComment,
  };
}
